import { apiClient, handleResponse } from './axios';

/**
 * Get all languages.
 */
async function getAll() {
  try {
    const response = await apiClient.get('/language');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getLanguage(languageId) {
  try {
    const response = await apiClient.get(`/language/${languageId}`);
    const language = await handleResponse(response);
    return language;
  } catch (error) {
    return error.response;
  }
}

const languageServices = {
  getAll,
  getLanguage,
};

export default languageServices;
